import { IdentityV2, PhoneV2 } from '@my-account/data-access/interfaces';
import { concatMap, map, take } from 'rxjs/operators';

import { AthleteManagementDao } from '@my-account/data-access/dao';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PersonalInformation } from '@shared/data-access/interfaces';
import { Store } from '@shared/data-access/services';

@Injectable({
	providedIn: 'root'
})
export class AthleteManagementPhoneService {

	constructor(private athleteManagementDao: AthleteManagementDao, private store: Store) {}

	/**
	 * @returns {Observable<Identity2>}
	 * @description
	 * patches the phone number and returns identity
	 * @param phone
	 */
	public patchPhone(phone: PhoneV2): Observable<IdentityV2> {
		return this.athleteManagementDao.patchPhone(phone).pipe(
			concatMap((result) => {
				return this.store.select<PersonalInformation>('PERSONAL_INFO').pipe(
					take(1),
					map((user: PersonalInformation) => {
						user.phoneNumbers = [
							{
								id:'1',
								phoneNumber: result.phone,
								phoneType: 0,
								isPrimary: false,
							}
						];
						this.store.set('PERSONAL_INFO', user);
						return result;
					}));
			})
		);
	}
}
